import { FC } from 'react';
import classNames from 'classnames';

import SBBIDButton from 'application/components/SBBIDButton';
import { AuthFormMode } from 'application/components/AuthForm/types';
import {
  YMWindow,
  isRoistatReady,
  YM_COUNTER_CLIENT_ID,
  ROISTAT_VISIT_ID,
  getYaId,
} from 'application/services/AnalyticsService';

import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';
import IconPhone from '@zvuk-b2b/react-uikit/ui/icons/Phone';
import IconMail from '@zvuk-b2b/react-uikit/ui/icons/Mail';

import { TEXTS } from './texts';

import styles from './index.module.scss';

export enum AuthMethodType {
  SBBID = 'SBBID',
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
}

const persistUTM = () => {
  if ((window as YMWindow).ym) {
    (window as YMWindow).ym?.(getYaId(), 'getClientID', (clientID: string) => {
      if (clientID.length !== 0) {
        localStorage.setItem(YM_COUNTER_CLIENT_ID, clientID);
      }
    });
  }

  if (isRoistatReady(window)) {
    localStorage.setItem(ROISTAT_VISIT_ID, window.roistat.getVisit());
  }
};

const getAuthMethod = (type: AuthMethodType, mode: AuthFormMode, onClick: (type: AuthMethodType) => void) => {
  switch (type) {
    case AuthMethodType.SBBID:
      return (
        <SBBIDButton
          elementId="button_sbbid"
          key="button_sbbid"
          withModal={mode === AuthFormMode.REGISTER}
          className={styles.AuthMethodListSberIdButton}
          title={TEXTS.BUTTON_SBBID_TITLE}
          onClick={persistUTM}
        />
      );
    case AuthMethodType.EMAIL:
      return (
        <Button
          elementId="button_method_email"
          key="button_method_email"
          className={styles.AuthMethodListExpandButton}
          type={ButtonType.SECONDARY}
          onClick={() => onClick(AuthMethodType.EMAIL)}>
          <IconMail className={styles.AuthMethodListExpandButtonIcon} />
          {TEXTS.BUTTON_EMAIL_TITLE}
        </Button>
      );
    case AuthMethodType.PHONE:
    default:
      return (
        <Button
          elementId="button_method_phone"
          key="button_method_phone"
          className={styles.AuthMethodListExpandButton}
          type={ButtonType.SECONDARY}
          onClick={() => onClick(AuthMethodType.PHONE)}>
          <IconPhone className={styles.AuthMethodListExpandButtonIcon} />
          {TEXTS.BUTTON_PHONE_TITLE}
        </Button>
      );
  }
};

type AuthMethodListProps = {
  methods: AuthMethodType[];
  mode: AuthFormMode;
  className?: string;
  onSelect: (type: AuthMethodType) => void;
};

const AuthMethodList: FC<AuthMethodListProps> = ({ mode, methods, className, onSelect }) => (
  <div className={classNames(styles.AuthMethodList, className)}>
    {methods.map((method) => getAuthMethod(method, mode, onSelect))}
  </div>
);

export default AuthMethodList;
